import React, { useEffect } from 'react';
import { TelegramUtils } from '@/utils/telegram';
import logoLight from '@/assets/itinder.svg';
import logoDark from '@/assets/itinder_dark.svg';

const SplashScreen: React.FC = () => {
  useEffect(() => {
    // Initialize Telegram WebApp
    TelegramUtils.init();
    
    // Note: Navigation is now handled by useBootstrap hook
    // No automatic navigation from splash screen
  }, []);

  const logo = TelegramUtils.isLightTheme ? logoDark : logoLight;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-tg-bg p-6">
      {/* Logo */}
      <div className="animate-scale-in">
        <img 
          src={logo} 
          alt="ITinder" 
          className="w-24 h-auto mb-8"
        />
      </div>
      
      {/* Loading indicator */}
      <div className="mt-8">
        <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default SplashScreen;
